import { APP_ENVIRONMENT, EnvironmentService } from '@accesso/adk-portal-shared';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService {
  private baseUrl: string;

  constructor(
    private http: HttpClient,
    @Inject(APP_ENVIRONMENT) private environment: EnvironmentService
  ) {
    this.baseUrl = `${environment.getEnvironmentProperties().adkPortalApiBaseUrl}/v1`;
  }

  getAllowedFeatureFlagByTag(tag: string): Observable<boolean> {
    return this.http.get<boolean>(`${this.baseUrl}/featureflag/${tag}/allowed`);
  }
}
